import React from 'react';
import Search from './Search';
import { SetupPage } from 'areas/shared/pages/setup';
import * as Formatter from 'fw/components/formatter/Formatter';
import { ContentBody } from 'areas/shared/components';
import { Button, Box } from "fw/components";
import dd214InfoTab from './dd214Info/DD214InfoTab';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Help from 'modules/app/Help'
import AuditInfoTab from './auditInfo/AuditInfoTab';
import DD214StatusLabel from 'areas/admin/shared/DD214StatusLabel';
import * as FormManager from 'fw/forms/form/FormManager';

class DD214Setup extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState() {
        return {
            list: [],
            loading: false,
            showGoToApplication: false
        };
    }

    componentDidMount() {
        this.setState({
            loading: true,
        }, () => { this.certificationIsSubmitted() });
    }

    certificationIsSubmitted = () => {
        if (this.props.match.params.certificationKey !== undefined) {
            var rq = { certificationKey: this.props.match.params.certificationKey };

            API.Admin.get('/dD214/certificationIsSubmitted', rq, {
                success: (r) => {
                    this.setState({ showGoToApplication: r.data.isSubmitted });
                }
            });
        }
    }

    handleBackToApplication = () => {
        const me = this;

        FormManager.checkUnsavedChanges(function () {
            me.props.history.push('/admin/certification/' + me.props.match.params.certificationKey + '/appReview');
        })
    }

    render() {
        var certificationKey = this.props.match.params.certificationKey;

        let opts = {
            setupKey: "dd214Setup",
            title: "DD214 Management",
            description: "Search or Upload DD214 File",
            showAddNew: certificationKey === undefined,
            addNewTitle: "Add New",
            helpKey: Help.dd214SetupHelpKey,
            addPrivilege: App.hasPrivilege("AdminDD214Setup"),
            enableColumnSettings: false,
            recentType: "dd214",
            redirectOnSingleResult: false,
            showTitle: false,
            list: {
                url: API.Admin.url('/dD214/search'),
                rowKey: "dD214Key",
                columns: [
                    { key: 'warning', name: '', sortable: false, width: 40, formatter: Formatter.Warning, cellClass: "text-center" },
                    { key: 'lastName', name: 'Last Name', sortable: true },
                    { key: 'firstName', name: 'First Name', sortable: true },
                    { key: 'gender', name: 'Gender', sortable: true },
                    { key: 'birthday', name: 'Date of Birth', sortable: true, formatter: Formatter.Date },
                    { key: 'ownerSSN', name: 'SSN', sortable: true },
                    { key: 'serviceBranchName', name: 'Branch of Service', sortable: true },
                    { key: 'fileUploaded', name: "Status", sortable: true, formatter: DD214StatusLabel, getRowMetaData: (row) => row, width: 150 }
                ]
            },
            tabs: [
                { key: "dd214InfoTab", title: "DD214 Info", comp: dd214InfoTab },
                { key: "auditInfo", title: "Audit Info", comp: AuditInfoTab }
            ]
        };

        return (
            <React.Fragment>
                <ContentBody>
                    <Box>
                    <SetupPage {...opts}
                            Search={Search}
                            triggerInitialSearch={true}
                            rowCount={30}
                        />
                        {this.state.showGoToApplication && certificationKey ?
                            <Button id="btnBackToApplication"
                                className="pull-right"
                                style={{ marginRight: "25px" }}
                                bsStyle="success"
                                onClick={this.handleBackToApplication}>Go to Application
                            </Button>
                            : null}
                    </Box>
                </ContentBody>
            </React.Fragment >
        );
    }
}
export default DD214Setup;



// WEBPACK FOOTER //
// ./src/areas/admin/dd214Setup/DD214Setup.js